import { render } from "./GalleryModify.vue?vue&type=template&id=2da277eb&scoped=true"
import script from "./GalleryModify.vue?vue&type=script&lang=js"
export * from "./GalleryModify.vue?vue&type=script&lang=js"

import "./GalleryModify.vue?vue&type=style&index=0&id=2da277eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da277eb"]])

export default __exports__